import {
  clearClientCookie,
  CookieKeys,
  getClientBooleanCookie,
} from '@finn/ui-utils';
import { useEffect, useState } from 'react';

export const useCartAvailability = () => {
  const [isCartNotAvailable, setIsCartNotAvailable] = useState(false);
  useEffect(() => {
    const handleCartNotAvailable = () => {
      const cartNotAvailable = getClientBooleanCookie(
        CookieKeys.VEHICLE_CART_NOT_AVAILABLE
      );
      setIsCartNotAvailable(cartNotAvailable);

      if (cartNotAvailable) {
        clearClientCookie(CookieKeys.VEHICLE_CART_NOT_AVAILABLE);
      }
    };

    handleCartNotAvailable();
  }, [setIsCartNotAvailable]);

  return isCartNotAvailable;
};
